module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[9]374.79deda8.woff2";